import axios from "axios";
import Cookies from "js-cookie";
import { getCasinoApiBase } from "../../utils/apiBase";
import { mockApi } from "../../services/mockApi";

/** Một dòng game trong sảnh — cùng shape tối thiểu như Slot.tsx */
export type NhTableListRow = {
  _id: string;
  name: string;
  showIcon?: string;
};

/**
 * Danh sách game theo sảnh — nạp từ mockApi đầy đủ các sảnh Nổ Hũ, fallback sang API casino nếu cần.
 */
export async function fetchNhTableList(roomKey: string): Promise<NhTableListRow[]> {
  try {
    const mockRes = await mockApi.getTableList(roomKey);
    const list = Array.isArray(mockRes.data) ? mockRes.data : [];
    if (list.length > 0) {
      return list.map((it: any, idx: number) => ({
        _id: `${roomKey}-${it?.id ?? idx}`,
        name: String(it?.name ?? ""),
        showIcon: it?.showIcon,
      }));
    }
  } catch (err) {
    console.error("fetchNhTableList mockApi error:", err);
  }

  const base = getCasinoApiBase();

  try {
    const token = Cookies.get("access_token");
    const response = await axios.get(`${base}/NH/tableList?typeGame=${roomKey}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    const raw = Array.isArray(response.data) ? response.data : [];
    return raw.map((it: any, idx: number) => ({
      _id: String(it?._id ?? it?.id ?? `${roomKey}-${idx}`),
      name: String(it?.name ?? ""),
      showIcon: it?.showIcon,
    }));
  } catch {
    return [];
  }
}
